import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
const RemoveFlowModal = ({ isShown, selectedFlow, flows, onClose, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const onConfirm = useCallback(() => {
        if (!selectedFlow) {
            return;
        }
        const { id } = selectedFlow;
        setIsLoading(true);
        flows
            .remove(id)
            .then(() => setIsLoading(false))
            .then(() => onClose());
    }, [selectedFlow, setIsLoading, onClose, flows]);
    if (!selectedFlow) {
        return null;
    }
    const { name } = selectedFlow;
    return (_jsx(ConfirmModal, Object.assign({ isShown: isShown, confirmText: "Delete", cancelText: "Cancel", headline: "Delete flow", confirmProps: { isLoading }, confirm: onConfirm, cancel: onClose }, { children: _jsxs("p", { children: ["Are you sure you want to delete the ", _jsx("strong", { children: name }), " flow?"] }) })));
};
export default RemoveFlowModal;
